/* eslint-disable import/no-unused-modules */
import React from 'react';

import {
  SelectedWeekHeader,
  HelpButton,
} from '@/pages/Assignment/strategic/components/LoopChart/atoms/WeeksNavigation/variants/styles';
import { utcToLocalDateСustomFormat } from '@/utils/time';
import { useWeekNavigationsContext } from '@/pages/Assignment/strategic/components/LoopChart/atoms/WeeksNavigation/context';
import { isCurrentWeek } from '@/pages/Assignment/strategic/components/LoopChart/variants/WeeklyLoopChart';

interface WeeksNavigationHeaderProps {
  onHelpClick: () => void;
}

export const WeeksNavigationHeader = ({ onHelpClick }: WeeksNavigationHeaderProps): JSX.Element => {
  const { selectedWeek, weeks } = useWeekNavigationsContext();

  return (
    <>
      {selectedWeek && (
        <SelectedWeekHeader isCurrentWeek={isCurrentWeek(selectedWeek)}>
          <p>
            <span>
              Week {selectedWeek.weekNumber}/{weeks.length}
            </span>{' '}
            · {utcToLocalDateСustomFormat(selectedWeek.weekStartTimestamp, 'MMM D')} -{' '}
            {utcToLocalDateСustomFormat(selectedWeek.weekEndTimestamp, 'MMM D')}
          </p>
          <HelpButton onClick={onHelpClick} />
        </SelectedWeekHeader>
      )}
    </>
  );
};
